import { RefObject, useEffect } from "react";

export const useScrollToQuestion = (container: RefObject<HTMLElement>, active: string | null) => {
  useEffect(() => {
    if (!container.current || !active) {
      return;
    } else if (container.current.scrollHeight <= container.current.clientHeight) {
      return;
    }
    const activeQuestion = document.getElementById(`question-${active}`);
    if (!activeQuestion) {
      return;
    }
    container.current.style.scrollBehavior = "smooth";
    let offsetTop = activeQuestion.offsetTop;
    let parent: HTMLElement = activeQuestion.offsetParent as HTMLElement;
    while (!!parent && parent !== container.current) {
      offsetTop += parent.offsetTop;
      parent = parent.offsetParent as HTMLElement;
    }
    const { clientHeight } = activeQuestion;
    // if the element is larger than the view port, we scroll to the top of the element
    if (clientHeight > container.current.clientHeight) {
      container.current.scrollTop = offsetTop;
      return;
    }
    // center the element in the scroll view
    const offsetY = Math.floor(offsetTop - (container.current.clientHeight - clientHeight) / 2);
    container.current.scrollTop = Math.max(0, Math.min(container.current.scrollHeight, offsetY));
  }, [container.current, active]);
};
